import "./ControlUnits.module.css";
import Header from "@/reusable_sections/Header";
import SchlSselTechnologieCopy from "@/pages/KeyService/sections/SchlSselTechnologieCopy";
import Expertise from "./sections/Expertise";
import PricingCopy from "@/pages/KeyService/sections/PricingCopy";
import Controlunitfaq from "./sections/Controlunitfaq";
import Inquiry from "./sections/Inquiry";
import PricingCopyCopy from "@/pages/KeyService/sections/PricingCopyCopy";
import Footer from "@/reusable_sections/Footer";
export default function ControlUnitsPage() {
  return <div>
      <Header />
      
      
      
      <SchlSselTechnologieCopy />
      
      <PricingCopy />
      <PricingCopyCopy />
      <Controlunitfaq />
      
      <Footer />
    
      
      </div>;
}